<template>
  <div :class="[_.empty, noMargin && _.noMargin]">
    <img :src="iconUrl" :class="_.icon" :style="iconStyle" />
    <div :class="_.message">
      {{ message }}
    </div>
    <div v-if="$slots.default || confirmText" :class="_.actions">
      <slot>
        <x-button
          v-if="confirmText"
          v-track="{
            ...confirmTrack,
            disabled: !confirmTrack,
          }"
          inline
          small
          @click="$emit('confirm')"
        >
          {{ confirmText }}
        </x-button>
      </slot>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { pxToRem } from '@/utils'

  export default Vue.extend({
    props: {
      // 图标
      icon: {
        type: String,
        default: require('./images/列表.png'),
      },

      // 类型：地址，购物车，列表，券包，搜索，网络，已下架
      type: {
        type: String,
        default: '',
      },

      // 图标宽度
      iconWidth: {
        type: Number,
        default: 150,
      },

      // 信息
      message: {
        type: String,
        default: '暂无数据',
      },

      // 确认按钮文本
      confirmText: {
        type: String,
        default: '',
      },

      // 无边距
      noMargin: {
        type: Boolean,
        default: false,
      },

      // 确认按钮埋点
      confirmTrack: {
        type: Object,
        default: undefined,
      },
    },

    computed: {
      iconUrl() {
        return this.type
          ? {
              // @index('./images/*.png', f => `'${f.name}': require('${f.path}${f.ext}'),`)
              列表: require('./images/列表.png'),
              券包: require('./images/券包.png'),
              地址: require('./images/地址.png'),
              已下架: require('./images/已下架.png'),
              搜索: require('./images/搜索.png'),
              网络: require('./images/网络.png'),
              购物车: require('./images/购物车.png'),
              // @endindex
            }[this.type]
          : this.icon
      },
      iconStyle() {
        return {
          width: `${pxToRem(this.iconWidth)}rem`,
        }
      },
    },
  })
</script>

<style lang="scss" module>
  .empty {
    padding: 100px 0;
    text-align: center;
    user-select: none;
    -webkit-touch-callout: none;
    display: flex;
    flex-direction: column;
    align-items: center;

    .message {
      max-width: 80%;
      font-size: 14px;
      color: #999999;
    }

    .actions {
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &.noMargin {
      padding: 0;
    }
  }
</style>
